<script lang="ts">
export default {
  name: "CharteValidator",
  props: {
    href: {
      type: String,
      default: "",
    },
  },
};
</script>

<template>
  <div class="pdf-container">
    <iframe
      :src="href"
      width="100%"
      height="600px"
      frameborder="0"
    />
  </div>
</template>

<style scoped>
.pdf-container {
  height: 600px;
  width: 100%;
  border: 1px solid #ddd; /* Optionnel */
}
</style>
